import React from 'react'
import MaxAlert from '@berlitz/alert'
import Button from '@berlitz/button'
import {
  ContentWrapper,
  ButtonWrapper,
  StyledRichText,
  StickyAlertWrapper,
} from '../style'

// following this pattern https://blog.hackages.io/conditionally-wrap-an-element-in-react-a8b9a47fab2
const ConditionalWrapper = ({ condition, wrapper, children }) => {
  return condition ? wrapper(children) : children
}

const Alert = ({
  alert,
  hideCloseButton,
  dismissAlert,
  isActive,
  fixed,
  index,
}) => {
  let alertHtml = ''
  if (alert.heading) alertHtml += `<strong>${alert.heading}</strong> `
  if (alert.content) alertHtml += `${alert.content}`
  const displayButtonClose = !hideCloseButton && alert.closeText
  const buttonInline = fixed ? alertHtml < 220 : true
  return (
    <ConditionalWrapper
      condition={fixed}
      wrapper={children => (
        <StickyAlertWrapper fixed isActive={isActive} index={index}>
          {children}
        </StickyAlertWrapper>
      )}
    >
      <MaxAlert type={alert.type} rounded={fixed}>
        <ContentWrapper fixed={fixed} buttonInline={buttonInline}>
          <StyledRichText dangerouslySetInnerHTML={{ __html: alertHtml }} />
          {((alert.buttonText && alert.buttonHref) || displayButtonClose) && (
            <ButtonWrapper buttonInline={buttonInline}>
              {alert.buttonText && alert.buttonHref && (
                <Button
                  small
                  buttonType={alert.type}
                  target="_blank"
                  href={alert.buttonHref}
                  as="a"
                >
                  {alert.buttonText}
                </Button>
              )}
              {displayButtonClose && (
                <Button
                  outline
                  buttonType={alert.type}
                  small
                  onClick={dismissAlert}
                >
                  {alert.closeText}
                </Button>
              )}
            </ButtonWrapper>
          )}
        </ContentWrapper>
      </MaxAlert>
    </ConditionalWrapper>
  )
}

export default Alert
